/**
 * ViewModel: Dashboard
 * Presentation logic for dashboard feature
 */

import type { FetchDashboardModel } from '../../domain/model/DashboardModel';
import { FetchDashboardUseCase } from '../../domain/usecase/FetchDashboardUseCase';

export const DashboardViewModel = ({
  setFetchingDashboard,
  setDashboardData,
}: {
  setFetchingDashboard: React.Dispatch<React.SetStateAction<boolean>>;
  setDashboardData: React.Dispatch<React.SetStateAction<FetchDashboardModel | null>>;
}) => {
  const fetchDashboard = async () => {
    try {
      setFetchingDashboard(true);
      const data = await FetchDashboardUseCase();
      setDashboardData(data);
    } catch (error) {
      console.error('Failed to fetch dashboard:', error);
      setDashboardData(null);
    } finally {
      setFetchingDashboard(false);
    }
  };

  return {
    fetchDashboard,
  };
};

